function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useEffect, useState } from 'react';
import { string, arrayOf, shape, func, bool } from 'prop-types';
import classnames from 'classnames';
import Menu from "semantic-ui-react/dist/es/collections/Menu/Menu.js";
import { debounce } from 'debounce';
import { Submenu } from "../../elements/Submenu";
import { size } from "../../../utils/size";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { Link } from "../../elements/Link";
import { Icon } from "../../elements/Icon";
import { testidFactory } from "../../../utils/testid";
import { HorizontalGutters } from "../../layout/HorizontalGutters";
import { HORIZONTAL_MENU_MARGINS } from "./constants";
var TEST_ID_PREFIX = 'horizontalMenu';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var items = _ref.items,
      onItemClick = _ref.onItemClick,
      hasOverflow = _ref.hasOverflow,
      className = _ref.className;
  var menuRef = useRef();
  var horizontalMenuRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isArrowLeftActive = _useState2[0],
      setIsArrowLeftActive = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isArrowRightActive = _useState4[0],
      setIsArrowRightActive = _useState4[1];

  var getArrowsOnScroll = function getArrowsOnScroll() {
    var menuPosition = menuRef.current.scrollLeft;
    var maxScroll = menuRef.current.scrollWidth - menuRef.current.clientWidth;

    if (menuPosition === 0 && maxScroll > 0) {
      setIsArrowLeftActive(false);
    } else {
      setIsArrowLeftActive(true);
    }

    if (menuPosition === maxScroll && maxScroll > 0) {
      setIsArrowRightActive(false);
    } else {
      setIsArrowRightActive(true);
    }
  };

  var getArrowsOnResize = function getArrowsOnResize() {
    var menuWrapper = menuRef.current;
    var menuWrapperContainer = horizontalMenuRef.current;
    var menuWrapperWidth = menuWrapper && menuWrapper.scrollWidth;
    var menuWrapperContainerWidth = menuWrapperContainer && menuWrapperContainer.getBoundingClientRect().width - HORIZONTAL_MENU_MARGINS;

    if (menuWrapperContainerWidth < menuWrapperWidth) {
      setIsArrowLeftActive(true);
      setIsArrowRightActive(true);
    } else {
      setIsArrowLeftActive(false);
      setIsArrowRightActive(false);
    }
  };

  useEffect(function () {
    getArrowsOnResize();

    if (menuRef.current && horizontalMenuRef.current) {
      global.window.addEventListener('resize', function () {
        return debounce(getArrowsOnResize(), 150);
      });
    }

    if (menuRef.current) {
      menuRef.current.addEventListener('wheel', function () {
        return getArrowsOnScroll();
      });
      return function () {
        menuRef.current.removeEventListener('wheel', getArrowsOnScroll);
        global.window.removeEventListener('resize', getArrowsOnResize);
      };
    }
  }, [menuRef.current]);

  var scrollTo = function scrollTo() {
    var begin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var domMenu = menuRef.current;
    var maxScroll = domMenu.scrollWidth - domMenu.clientWidth;
    domMenu.scrollLeft = begin ? 0 : maxScroll;
    getArrowsOnScroll();
  };

  return React.createElement("nav", {
    className: classnames('horizontal-menu', className, {
      'is-overflowed': hasOverflow
    }),
    "data-testid": testid(),
    ref: horizontalMenuRef
  }, React.createElement("div", {
    className: classnames('arrow left', {
      'is-active': isArrowLeftActive
    }),
    "data-testid": testid('arrow-left'),
    onClick: function onClick() {
      scrollTo(true);
    },
    role: "button"
  }, React.createElement(Icon, {
    name: "chevron left"
  })), React.createElement(HorizontalGutters, null, React.createElement(Menu, {
    "data-testid": testid('menu')
  }, React.createElement("div", {
    className: "menu-wrapper",
    "data-testid": testid('menu-wrapper'),
    ref: menuRef
  }, items.map(function (item, index) {
    var id = item.id,
        href = item.href,
        text = item.text,
        isActive = item.isActive,
        subItems = item.subItems;
    return size(subItems) > 0 ? React.createElement("div", {
      className: "item",
      key: buildKeyFromStrings(text, index)
    }, React.createElement(Submenu, {
      isMenuItem: true,
      isSimple: true,
      isTriggerUnderlined: index === isActive,
      isTriggeredOnHover: true,
      items: subItems
    }, text)) : React.createElement(Menu.Item, {
      active: isActive,
      "data-testid": testid("menu-item-".concat(index)),
      href: href,
      key: "menu-item-".concat(index, "-").concat(id || ''),
      name: text,
      onClick: onItemClick && function (event) {
        return onItemClick(item, event);
      }
    }, React.createElement(Link, null, text));
  })))), React.createElement("div", {
    className: classnames('arrow right', {
      'is-active': isArrowRightActive
    }),
    "data-testid": testid('arrow-right'),
    onClick: function onClick() {
      scrollTo();
    }
  }, React.createElement(Icon, {
    name: "chevron right"
  })));
};
Component.displayName = 'HorizontalMenu';
Component.defaultProps = {
  items: [],
  onItemClick: undefined,
  className: '',
  hasOverflow: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  className: string,
  hasOverflow: bool,
  items: arrayOf(shape({
    id: string,
    href: string,
    text: string.isRequired,
    isActive: bool,
    subItems: arrayOf(shape({
      href: string,
      target: string,
      text: string.isRequired
    }))
  })),
  onItemClick: func
} : {};